// src/services/Pdf.js
import jsPDF from 'jspdf';
import Api from '../../services/Api'
import logoPrefeitura from '../../../src/imagens/prefeitura_ouro_preto_logo_1.png'
import logoGente from '../../../src/imagens/20191205 - Logo GENTE.png'

class PdfGeneralCondiction {
  static async gerarRelatorio(distrito, categoria, subcategoria, natureza, carro, energia, agua, fossa, lixo, esgoto, carroImage, energiaImage, aguaImage, captacaoAguaImage, fossaImage, lixoImage, esgotoImage) {
    const doc = new jsPDF();
    const inscricao = null;
    const proprietario = null;
    
    natureza = this.ajustaVariavel(natureza);

    carro = this.ajustaBooleano(carro);
    energia = this.ajustaBooleano(energia);
    agua = this.ajustaBooleano(agua);

    fossa = this.ajustaVariavel(fossa);
    lixo = this.ajustaVariavel(lixo);
    esgoto = this.ajustaVariavel(esgoto);

    const propriedades = await Api.getNumeroPropriedades(distrito, categoria, natureza, inscricao, proprietario, null, null, null, null);
    const areaMedia = await Api.getAreaMedia(distrito, categoria, natureza, inscricao, proprietario, null, null, null, null);

    let carroData = await Api.getPossuiCarro(distrito, categoria, natureza, inscricao, proprietario, energia, agua, fossa, lixo, esgoto);
    let energiaData = await Api.getEnergiaEletrica(distrito, categoria, natureza, inscricao, proprietario, carro, agua, fossa, lixo, esgoto);
    let aguaData = await Api.getAbastecimentoAgua(distrito, categoria, natureza, inscricao, proprietario, carro, energia, fossa, lixo, esgoto);

    let fossaData = await Api.getTipoFossa(distrito, categoria, natureza, inscricao, proprietario, carro, energia, agua, lixo, esgoto);
    let lixoData = await Api.getDescarteLixo(distrito, categoria, natureza, inscricao, proprietario, carro, energia, agua, fossa, esgoto);
    let esgotoData = await Api.getDescarteEsgoto(distrito, categoria, natureza, inscricao, proprietario, carro, energia, agua, fossa, lixo);

    carroData = this.ajustarDadosBooleano(carroData.value);
    energiaData = this.ajustarDadosBooleano(energiaData.value);
    aguaData = this.ajustarDadosBooleano(aguaData.value);

    fossaData = this.ajustarDadosFossa(fossaData.value);
    lixoData = this.ajustarDadosLixo(lixoData.value);
    esgotoData = this.ajustarDadosEsgoto(esgotoData.value);

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);

    // Considerações Iniciais
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text('Considerações iniciais', 10, 40)
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    const consideracao1 = '      As informações apresentadas neste relatório foram extraídas do dashboard oficial do Censo Agropecuário de Ouro Preto – MG. Esse Censo constituiu uma das principais etapas do Plano Municipal de Desenvolvimento Rural de Ouro Preto, desenvolvido pela Secretaria Municipal de Agropecuária em parceria com a Universidade Federal de Viçosa.'
    const consideracao2 = '    O objetivo central do levantamento foi reunir informações sobre os estabelecimentos e atividades agropecuárias, contemplando aspectos como a caracterização do produtor e da propriedade, a economia e o emprego no meio rural, além da pecuária, lavoura e agroindústria.'
    const consideracao3 = '    A coleta de dados ocorreu por meio do Boletim de Cadastro Rural (BCR), formulário estruturado para identificar as propriedades, sua infraestrutura, as condições socioeconômicas dos produtores e as atividades desenvolvidas.'
    const consideracao4 = '   Nos tópicos a seguir, são sintetizados alguns dos principais resultados do Censo, apresentados em tabelas, gráficos e mapas.';
    doc.text(consideracao1, 10, 50, { maxWidth: 190, align: 'justify' });
    doc.text(consideracao2, 10, 70, { maxWidth: 190, align: 'justify' });
    doc.text(consideracao3, 10, 85, { maxWidth: 190, align: 'justify' });
    doc.text(consideracao4, 10, 100, { maxWidth: 190, align: 'justify' });

    // Lista de condições e filtros
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Lista de condições e filtros aplicados", 10, 115);

    let y = 125;
    const filtros = [
      ["Inscrição/Código da propriedade: ", inscricao || "Não informado"],
      ["Nome do proprietário:", proprietario || "Não informado"],
      ["Distrito:", distrito || "Não informado"],
      ["Categoria de produção:", categoria || "Não informado"],
      ["Subcategoria de produção:", subcategoria || "Não informado"],
      ["Natureza de produção: ", natureza || "Todas"],
      ["Possui carro próprio:", carro || "Não informado"],
      ["Possui energia elétrica:", energia || "Não informado"],
      ["possui abastecimento de água: ", agua || "Não informado"],
      ["Tipo de fossa:", fossa || "Não informado"],
      ["Descarte de lixo:", lixo || "Não informado"],
      ["Descarte de esgoto:", esgoto || "Não informado"],
    ];

    doc.setFontSize(12);

    filtros.forEach(([label, valor]) => {
      // Marcador
      doc.setFont("helvetica", "normal");
      doc.text("\u2022", 10, y);

      // Label em negrito
      doc.setFont("helvetica", "bold");
      doc.text(label, 15, y);

      doc.setFont("helvetica", "normal");
      doc.text(String(valor), 15 + doc.getTextWidth(label) + 5, y);

      y += 6;
    });

    y+=5;
    // Indicadores
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Informações Gerais", 10, y);
    y += 10;

    const indicadores = [
      ["Propriedades cadastradas:   ", propriedades.value],
      ["Área Média(ha):   ", areaMedia.value.toFixed(2)],
    ];

    doc.setFontSize(12);

    indicadores.forEach(([label, valor]) => {
      doc.setFont("helvetica", "normal");
      doc.text("\u2022", 10, y);

      doc.setFont("helvetica", "bold");
      doc.text(label, 15, y);

      doc.setFont("helvetica", "normal");
      doc.text(String(valor), 15 + doc.getTextWidth(label) + 2, y);

      y += 6;
    });

    y +=5;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);

    doc.text('Condições gerais', 10, y);

    y += 10;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    doc.text('      Os gráficos e tabelas apresentados a seguir descrevem as condições gerais das propriedades contempladas no conjunto de dados analisado. São demonstradas a quantidade absoluta e a participação percentual das propriedades que possuem ou não serviços básicos, como abastecimento de água, fornecimento de energia elétrica e coleta de lixo e esgoto. Além disso, são detalhados os tipos de fossa utilizados, as formas de captação de água adotadas e a presença de veículos nas propriedades.', 10, y, {maxWidth:190})

    doc.addPage()

    this.gerarCabecalho(doc, logoGente, logoPrefeitura)
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");

    y = 35;

    const imgSize = 64

    doc.addImage(carroImage, 'PNG', doc.internal.pageSize.getWidth() / 2 - imgSize/2, y, imgSize, imgSize);
    y+=(imgSize+10);
    doc.text(`      O gráfico acima demonstra que ${carroData['02 - Sim']} (${this.calcPercentual(carroData['02 - Sim'], propriedades.value)}%) das propriedades possuem carro próprio. Já os ${carroData['01 - Não']}(${this.calcPercentual(carroData['01 - Não'], propriedades.value)}%) não possuem.`, 10, y, {maxWidth:190, align: 'justify'})

    y+=10;

    doc.addImage(energiaImage, 'PNG', doc.internal.pageSize.getWidth() / 2 - imgSize/2, y, imgSize, imgSize);
    y+=(imgSize+10);

    doc.text(`      Entre as propriedades analisadas, ${energiaData['02 - Sim']} (${this.calcPercentual(energiaData['02 - Sim'], propriedades.value)}%) possuem energia elétrica e ${energiaData['01 - Não']}(${this.calcPercentual(energiaData['01 - Não'], propriedades.value)}%) não possuem.`, 10, y, {maxWidth:190, align: 'justify'})

    y+=10;

    doc.addImage(aguaImage, 'PNG', doc.internal.pageSize.getWidth() / 2 - imgSize/2, y, imgSize, imgSize);
    y+=(imgSize+10);

    doc.text(`     Constata-se que ${aguaData['02 - Sim']} (${this.calcPercentual(aguaData['02 - Sim'], propriedades.value)}%) das propriedades possuem abastecimento de água, ao passo que ${aguaData['01 - Não']}(${this.calcPercentual(aguaData['01 - Não'], propriedades.value)}%) não possuem.`, 10, y, {maxWidth:190, align: 'justify'})

    doc.addPage()
    this.gerarCabecalho(doc, logoGente, logoPrefeitura)
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");

    y = 35;
    const imgSizeX = 100;
    const imgSize2 = 60;

    doc.addImage(fossaImage, 'PNG', doc.internal.pageSize.getWidth() / 2 - imgSizeX/2, y, imgSizeX, imgSize2);
    y+=(imgSize2+10);

    doc.text(`      Com relação ao tipo de fossa, observou-se a seguinte distribuição: Fossa seca com ${fossaData['01 - Fossa Seca']} propriedades (${this.calcPercentual(fossaData['01 - Fossa Seca'], propriedades.value)}%), Fossa absorvente com ${fossaData['02 - Fossa Absorvente']} propriedades (${this.calcPercentual(fossaData['02 - Fossa Absorvente'], propriedades.value)}%), Fossa negra com ${fossaData['04 - Fossa Negra']} propriedades (${this.calcPercentual(fossaData['04 - Fossa Negra'], propriedades.value)}%), Fossa séptica com ${fossaData['03 - Fossa Séptica']} propriedades (${this.calcPercentual(fossaData['03 - Fossa Séptica'], propriedades.value)}%), e ${fossaData['Não Informado']} propriedades (${this.calcPercentual(fossaData['Não Informado'], propriedades.value)}%) restantes não informaram.`, 10, y, {maxWidth:190, align: 'justify'})

    y+=15;

    doc.addImage(lixoImage, 'PNG', doc.internal.pageSize.getWidth() / 2 - imgSizeX/2, y, imgSizeX, imgSize2);
    y+=(imgSize2+10);

    doc.text(`      No que se refere a coleta de lixo, registrou-se: ${lixoData['03 - Coleta Pública']} propriedades (${this.calcPercentual(lixoData['03 - Coleta Pública'], propriedades.value)}%) com coleta pública de lixo, ${lixoData['01 - Queima']} propriedades (${this.calcPercentual(lixoData['01 - Queima'], propriedades.value)}%) optam pela queima, ${lixoData['02 - Soterramento']}  propriedades (${this.calcPercentual(lixoData['02 - Soterramento'], propriedades.value)}%) pelo soterramento e os ${lixoData['04 - Outro']} (${this.calcPercentual(lixoData['04 - Outro'], propriedades.value)}%) restantes utilizam algum outro método de descarte.`, 10, y, {maxWidth:190, align: 'justify'})

    y+=15;

    doc.addImage(esgotoImage, 'PNG', doc.internal.pageSize.getWidth() / 2 - imgSizeX/2, y, imgSizeX, imgSize2);
    y+=(imgSize2+10);

    doc.text(`      Entre as propriedades, ${esgotoData['01 - Curso Dágua']} (${this.calcPercentual(esgotoData['01 - Curso Dágua'], propriedades.value)}%) descartam o esgoto em curso dágua, ${esgotoData['02 - Fossa']} (${this.calcPercentual(esgotoData['02 - Fossa'], propriedades.value)}%) em fossa , ${esgotoData['03 - TEVAP/Tratamento']} (${this.calcPercentual(esgotoData['03 - TEVAP/Tratamento'], propriedades.value)}%) são tratados e os ${esgotoData['04 - Não há Produção']} (${this.calcPercentual(esgotoData['04 - Não há Produção'], propriedades.value)}%) restantes não produzem esgoto.`, 10, y, {maxWidth:190, align: 'justify'})

    y+=15;

    doc.addPage()

    this.gerarCabecalho(doc, logoGente, logoPrefeitura)
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");

    y = 35;

    doc.addImage(captacaoAguaImage, 'PNG', doc.internal.pageSize.getWidth() / 2 - 70, y, 140, 70);
    y+=(80);

    doc.text('      A tabela descreve em valores absolutos, o número de propriedades que utilizam cada tipo de captação de água.',10, y, {maxWidth:190, align: 'justify'});

    const fileName = 'Relatorio_CondicoesGerais_' + distrito + '_' + categoria + '_' + this.dataAtual() + ".pdf";
    doc.save(fileName);
  }

  static gerarCabecalho(doc, logoEsq, logoDir) {
      // Logo à esquerda
      if (logoEsq) {
          doc.addImage(logoEsq, "PNG", 10, 10, 30, 20);
      }

      // Logo à direita
      if (logoDir) {
          doc.addImage(logoDir, "PNG", 170, 10, 30, 15);
      }

      // Título central
      doc.setFontSize(14);
      doc.text("Relatório de condições gerais das propriedades", doc.internal.pageSize.getWidth() / 2, 15, { align: "center" });
      doc.text("rurais cadastradas no censo agropecuário", doc.internal.pageSize.getWidth() / 2, 21, { align: "center" });

      // Informações extras
      doc.setFontSize(8);
      doc.text(`Data: ${new Date().toLocaleDateString()}`, 170, 28);

      // Linha divisória
      doc.setDrawColor(150);
      doc.line(10, 32, 200, 32);
  }

  static ajustaBooleano(val){
    if (val === 'Ambos'){
      val = null;
    }

    return val;
  }

  static ajustaVariavel(val){
    if (val != null && val.toLowerCase() === 'todos'){
      val = null;
    }

    return val;
  }

  static ajustarDadosFossa(fossaData){
    const chaves = ['01 - Fossa Seca', '02 - Fossa Absorvente', '03 - Fossa Séptica', '04 - Fossa Negra', 'Não Informado'];

    for(let chave in chaves){
      if (!(chave in Object.keys(fossaData))){
        fossaData[chave] = 0;
      }
    }
    return fossaData
  }

  static ajustarDadosLixo(lixoData){
    const chaves = ['01 - Queima', '02 - Soterramento', '03 - Coleta Pública', '04 - Outro'];

    for(let chave in chaves){
      if (!(chave in Object.keys(lixoData))){
        lixoData[chave] = 0;
      }
    }
    return lixoData
  }

  static ajustarDadosEsgoto(esgotoData){
    const chaves = ['01 - Curso Dágua', '02 - Fossa', '03 - TEVAP/Tratamento', '04 - Não há Produção'];

    for(let chave in chaves){
      if (!(chave in Object.keys(esgotoData))){
        esgotoData[chave] = 0;
      }
    }
    return esgotoData
  }

  static ajustarDadosBooleano(data){
    const chaves = ['02 - Sim', '01 - Não'];

    for(let chave in chaves){
      if (!(chave in Object.keys(data))){
        data[chave] = 0;
      }
    }
    return data
  }

  static calcPercentual(val, total){
    const res = (val/total)*100;
    return res.toFixed(2);
  }

  static dataAtual(){
    const hoje = new Date();

    const data = hoje.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    });

    const formatada = data.replace(/\//g, "_");

    return  formatada;

  }

}

export default PdfGeneralCondiction;
